import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

const FALLBACK_TYPES = {
  without_protection: 'withoutProtection',
  only_protection: 'onlyProtection',
} as const

type FallbackType =
  | (typeof FALLBACK_TYPES)[keyof typeof FALLBACK_TYPES]
  | 'default'

export function useFallbackParameters() {
  const $httpFetch = useHttpFetch()
  const logger = useLogger()

  function getFallbackTypeFromRuleContexts(
    ruleContext: readonly string[] | undefined,
  ): FallbackType {
    if (!ruleContext || ruleContext.length === 0) return 'default'

    for (const [key, value] of Object.entries(FALLBACK_TYPES)) {
      if (ruleContext.includes(key)) {
        return value
      }
    }

    return 'default'
  }

  async function fetchFallbackParameters(objectIds: string[]) {
    const results = await Promise.allSettled(
      objectIds.map(async (objectId) => {
        const productId = objectId.split('_')[0]

        const result = await $httpFetch(
          '/bm/recommendation/fallbacks/:productId',
          {
            pathParams: {
              productId,
            },
          },
        )

        return { objectId, result }
      }),
    )

    const fallbackParameters: Record<string, Record<string, string>> = {}

    for (const result of results) {
      if (result.status === 'fulfilled') {
        fallbackParameters[result.value.objectId] = result.value.result
      } else {
        logger.error('[S&R] Failed to fetch fallback parameters', {
          type: 'API_REQUEST_FAIL',
          endpointName: 'recommendationFallbackParameters',
          error: result.reason,
          owners: ['bot-squad-search-and-recommendation-front'],
        })
      }
    }

    return fallbackParameters
  }

  return { getFallbackTypeFromRuleContexts, fetchFallbackParameters }
}
